import type { CreateSixModalInformation } from "@/types/create-six.types";
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { withLoader } from "@/store/thunks/thunkWrappers";

export const fetchCreateSixModalInformationThunk = createAppAsyncThunk<
  CreateSixModalInformation
>(
  "createSix/fetchCreateSixModalInformation",
  withLoader(
    async(_, { extra }) => await extra.createSixService.getCreateSixModalInformation()
  )
);
